import { useSyncExternalStore } from 'react';
import { CONSENT_EVENT, CONSENT_CATEGORY, type ConsentCategory, type ConsentSnapshot } from '@/consent/contract';
import { hasConsent } from '@/core/lib/consent';

const NO_DECISION: ConsentSnapshot | null = null;

const subscribe = (onStoreChange: () => void) => {
  window.addEventListener(CONSENT_EVENT, onStoreChange);
  return () => window.removeEventListener(CONSENT_EVENT, onStoreChange);
};

const getSnapshot = (): ConsentSnapshot | null => window.linkieConsent?.getSnapshot() ?? NO_DECISION;

const getServerSnapshot = (): ConsentSnapshot | null => NO_DECISION;

export const useConsentSnapshot = (): ConsentSnapshot | null =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export const useConsent = (category: ConsentCategory): boolean =>
  useSyncExternalStore(
    subscribe,
    () => hasConsent(category),
    () => category === CONSENT_CATEGORY.NECESSARY,
  );

export default useConsent;
